type IndicatorColor = 'green' | 'amber' | 'red' | 'blue';

interface LiveIndicatorProps {
  color: IndicatorColor;
  label?: string;
}

const COLOR_MAP: Record<IndicatorColor, string> = {
  green: '#34D399',
  amber: '#FBBF24',
  red: '#F87171',
  blue: '#60A5FA',
};

export default function LiveIndicator({ color, label }: LiveIndicatorProps) {
  const hex = COLOR_MAP[color];

  return (
    <span className="live-indicator-wrapper" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
      <span
        className="live-indicator-dot"
        style={{
          width: '4px',
          height: '4px',
          borderRadius: '50%',
          backgroundColor: hex,
          boxShadow: `0 0 4px ${hex}`,
          display: 'inline-block',
          animation: 'liveIndicatorPulse 2s ease-in-out infinite',
        }}
      />
      {label && (
        <span style={{ fontSize: '11px', color: hex, fontWeight: 500, lineHeight: 1 }}>
          {label}
        </span>
      )}
      <style>{`
        @keyframes liveIndicatorPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        @media (prefers-reduced-motion: reduce) {
          .live-indicator-dot {
            animation: none !important;
          }
        }
      `}</style>
    </span>
  );
}
